import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  // Handle hash-based routing
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash === '#privacy-policy' || window.location.pathname === '/privacy-policy') {
        setCurrentPage('privacy-policy');
      } else if (hash === '#terms-and-conditions' || window.location.pathname === '/terms-and-conditions') {
        setCurrentPage('terms');
      } else if (hash === '#support' || window.location.pathname === '/support') {
        setCurrentPage('support');
      } else {
        setCurrentPage('home');
      }
    };

    // Check hash on initial load
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const navigateTo = (page) => {
    if (page === 'home') {
      window.location.hash = '';
      setCurrentPage('home');
    } else if (page === 'privacy-policy') {
      window.location.hash = 'privacy-policy';
      setCurrentPage('privacy-policy');
    } else if (page === 'terms') {
      window.location.hash = 'terms-and-conditions';
      setCurrentPage('terms');
    } else if (page === 'support') {
      window.location.hash = 'support';
      setCurrentPage('support');
    }
  };

  if (currentPage === 'privacy-policy') {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#fff',
        padding: '40px 20px',
        overflowY: 'auto',
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          paddingBottom: '60px',
        }}>
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); navigateTo('home'); }}
            style={{
              display: 'inline-block',
              marginBottom: '32px',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: '600',
              backgroundColor: '#f3f4f6',
              color: '#000',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              textDecoration: 'none',
            }}
          >
            ← Back
          </a>
          
          <h1 style={{
            fontSize: '48px',
            fontWeight: '700',
            color: '#000',
            marginBottom: '32px',
          }}>
            Privacy Policy
          </h1>
          
          <div style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#374151',
          }}>
            <p style={{ marginBottom: '24px' }}>
              <strong>Last Updated:</strong> January 2025
            </p>

            <p style={{ marginBottom: '24px' }}>
              This Privacy Policy describes how Pique ("we", "us", or "our") collects, uses, and shares information about you when you use our mobile application ("App").
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              1. Information We Collect
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Pique collects the following information to provide our services:
            </p>
            <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}><strong>Location data:</strong> We collect your precise location to show you other users within 100 feet of you. Location is only collected while you are actively using the app.</li>
              <li style={{ marginBottom: '8px' }}><strong>Profile information:</strong> Username, photos, bio, relationship status (dating mode), job title and company (networking mode)</li>
              <li style={{ marginBottom: '8px' }}><strong>Authentication data:</strong> Information provided through Apple Sign-In or Google Sign-In (name, email)</li>
              <li style={{ marginBottom: '8px' }}><strong>Messages:</strong> Content of messages sent through the app to other users</li>
              <li style={{ marginBottom: '8px' }}><strong>Device information:</strong> Device type and push notification tokens for delivering notifications</li>
            </ul>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              2. How We Use Your Information
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We use your information to:
            </p>
            <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>Display your profile to other nearby users within the app</li>
              <li style={{ marginBottom: '8px' }}>Enable messaging and connection features between users</li>
              <li style={{ marginBottom: '8px' }}>Send push notifications about new messages and connection requests</li>
              <li style={{ marginBottom: '8px' }}>Process and manage premium subscriptions</li>
              <li style={{ marginBottom: '8px' }}>Improve and maintain our services</li>
              <li style={{ marginBottom: '8px' }}>Respond to your requests and support inquiries</li>
            </ul>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              3. Data Sharing
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We do not sell your personal data. We may share your information in the following circumstances:
            </p>
            <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}><strong>With other users:</strong> Your profile information is visible to other users within 100 feet of you based on proximity and your privacy settings</li>
              <li style={{ marginBottom: '8px' }}><strong>Service providers:</strong> We use Firebase (Google Cloud) for data storage, authentication, and push notifications</li>
              <li style={{ marginBottom: '8px' }}><strong>Legal requirements:</strong> We may disclose information if required by law or to protect our rights</li>
            </ul>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              4. Data Storage and Security
            </h2>
            <p style={{ marginBottom: '24px' }}>
              Your data is stored securely using Google Firebase infrastructure. We implement industry-standard security measures including encryption in transit and at rest. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              5. Data Retention
            </h2>
            <p style={{ marginBottom: '24px' }}>
              We retain your data for as long as your account is active. Messages between non-connected users are automatically deleted after 7 days. You may request deletion of your account and all associated data at any time.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              6. Your Rights
            </h2>
            <p style={{ marginBottom: '16px' }}>
              You have the right to:
            </p>
            <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>Access the personal data we hold about you</li>
              <li style={{ marginBottom: '8px' }}>Request correction of inaccurate data</li>
              <li style={{ marginBottom: '8px' }}>Request deletion of your account and data</li>
              <li style={{ marginBottom: '8px' }}>Withdraw consent for location tracking by disabling location permissions</li>
            </ul>
            <p style={{ marginBottom: '24px' }}>
              To exercise these rights, please contact us at support@pique.network or use the account deletion feature in the app settings.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              7. Children's Privacy
            </h2>
            <p style={{ marginBottom: '24px' }}>
              Pique is not intended for users under 18 years of age. We do not knowingly collect information from children under 18. If we learn we have collected information from a child under 18, we will delete that information promptly.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              8. Changes to This Policy
            </h2>
            <p style={{ marginBottom: '24px' }}>
              We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the "Last Updated" date.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              9. Contact Us
            </h2>
            <p style={{ marginBottom: '24px' }}>
              If you have questions about this Privacy Policy or our data practices, please contact us at:<br />
              <strong>Email:</strong> support@pique.network<br />
              <strong>Website:</strong> https://pique.network
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (currentPage === 'terms') {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#fff',
        padding: '40px 20px',
        overflowY: 'auto',
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          paddingBottom: '60px',
        }}>
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); navigateTo('home'); }}
            style={{
              display: 'inline-block',
              marginBottom: '32px',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: '600',
              backgroundColor: '#f3f4f6',
              color: '#000',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              textDecoration: 'none',
            }}
          >
            ← Back
          </a>
          
          <h1 style={{
            fontSize: '48px',
            fontWeight: '700',
            color: '#000',
            marginBottom: '32px',
          }}>
            Terms and Conditions
          </h1>
          
          <div style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#374151',
          }}>
            <p style={{ marginBottom: '24px' }}>
              <strong>Last Updated:</strong> January 2025
            </p>

            <p style={{ marginBottom: '24px' }}>
              These Terms and Conditions ("Terms") govern your use of the Pique mobile application ("App") operated by Pique ("we", "us", or "our"). By using our App, you agree to be bound by these Terms.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              1. Acceptance of Terms
            </h2>
            <p style={{ marginBottom: '24px' }}>
              By downloading, installing, or using Pique, you agree to these Terms and Conditions and our Privacy Policy. If you do not agree to these Terms, please do not use the App.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              2. Eligibility
            </h2>
            <p style={{ marginBottom: '24px' }}>
              You must be at least 18 years old to use Pique. By using the App, you represent and warrant that you are at least 18 years of age and have the legal capacity to enter into these Terms.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              3. Description of Service
            </h2>
            <p style={{ marginBottom: '24px' }}>
              Pique is a location-based social networking application that allows users to discover and connect with other users within 100 feet of their location. The App offers two modes: Dating Mode for meeting potential romantic partners, and Networking Mode for professional connections.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              4. User Accounts
            </h2>
            <p style={{ marginBottom: '16px' }}>
              To use Pique, you must create an account using Apple Sign-In or Google Sign-In. You are responsible for:
            </p>
            <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>Maintaining the confidentiality of your account</li>
              <li style={{ marginBottom: '8px' }}>All activities that occur under your account</li>
              <li style={{ marginBottom: '8px' }}>Providing accurate and truthful profile information</li>
            </ul>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              5. User Conduct
            </h2>
            <p style={{ marginBottom: '16px' }}>
              You agree not to:
            </p>
            <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>Harass, abuse, threaten, or harm other users</li>
              <li style={{ marginBottom: '8px' }}>Post false, misleading, or deceptive information</li>
              <li style={{ marginBottom: '8px' }}>Use the App for any illegal purposes</li>
              <li style={{ marginBottom: '8px' }}>Impersonate any person or entity</li>
              <li style={{ marginBottom: '8px' }}>Upload inappropriate, offensive, or explicit content</li>
              <li style={{ marginBottom: '8px' }}>Attempt to gain unauthorized access to other accounts or systems</li>
              <li style={{ marginBottom: '8px' }}>Use the App to spam or solicit other users</li>
              <li style={{ marginBottom: '8px' }}>Violate any applicable laws or regulations</li>
            </ul>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              6. Premium Subscriptions
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Pique offers optional premium subscriptions with the following terms:
            </p>
            <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>Subscriptions are billed through Apple's App Store</li>
              <li style={{ marginBottom: '8px' }}>Free trials, if offered, automatically convert to paid subscriptions unless cancelled before the trial period ends</li>
              <li style={{ marginBottom: '8px' }}>Subscriptions automatically renew unless cancelled at least 24 hours before the end of the current billing period</li>
              <li style={{ marginBottom: '8px' }}>You can manage and cancel subscriptions in your Apple ID Account Settings</li>
              <li style={{ marginBottom: '8px' }}>No refunds are provided for partial subscription periods</li>
              <li style={{ marginBottom: '8px' }}>Prices are subject to change with notice</li>
            </ul>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              7. Content
            </h2>
            <p style={{ marginBottom: '24px' }}>
              You retain ownership of content you post on Pique. By posting content, you grant us a non-exclusive, worldwide, royalty-free license to use, display, and distribute your content within the App for the purpose of providing our services.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              8. Termination
            </h2>
            <p style={{ marginBottom: '24px' }}>
              We reserve the right to suspend or terminate your account at any time, with or without notice, for violations of these Terms or for any other reason at our sole discretion. You may delete your account at any time through the App settings.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              9. Disclaimer of Warranties
            </h2>
            <p style={{ marginBottom: '24px' }}>
              Pique is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee the accuracy of user profiles, the behavior of other users, or that the App will be uninterrupted or error-free. You use the App at your own risk.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              10. Limitation of Liability
            </h2>
            <p style={{ marginBottom: '24px' }}>
              To the maximum extent permitted by law, Pique and its operators shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the App, including but not limited to damages for loss of profits, data, or other intangibles, even if we have been advised of the possibility of such damages.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              11. Safety
            </h2>
            <p style={{ marginBottom: '24px' }}>
              While we strive to create a safe environment, we cannot guarantee the conduct of users. You are solely responsible for your interactions with other users. We encourage you to exercise caution and use good judgment when meeting people through the App.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              12. Changes to Terms
            </h2>
            <p style={{ marginBottom: '24px' }}>
              We may update these Terms from time to time. We will notify you of material changes by posting the updated Terms in the App. Your continued use of the App after changes constitutes acceptance of the new Terms.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              13. Governing Law
            </h2>
            <p style={{ marginBottom: '24px' }}>
              These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              14. Contact Us
            </h2>
            <p style={{ marginBottom: '24px' }}>
              If you have questions about these Terms, please contact us at:<br />
              <strong>Email:</strong> support@pique.network<br />
              <strong>Website:</strong> https://pique.network
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (currentPage === 'support') {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#fff',
        padding: '40px 20px',
        overflowY: 'auto',
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          paddingBottom: '60px',
        }}>
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); navigateTo('home'); }}
            style={{
              display: 'inline-block',
              marginBottom: '32px',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: '600',
              backgroundColor: '#f3f4f6',
              color: '#000',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              textDecoration: 'none',
            }}
          >
            ← Back
          </a>
          
          <h1 style={{
            fontSize: '48px',
            fontWeight: '700',
            color: '#000',
            marginBottom: '32px',
          }}>
            Support
          </h1>
          
          <div style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#374151',
          }}>
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              Contact Us
            </h2>
            <p style={{ marginBottom: '24px' }}>
              Need help with Pique? We're here to assist you.<br /><br />
              <strong>Email:</strong> support@pique.network<br /><br />
              We typically respond within 24-48 hours.
            </p>
            
            <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#000' }}>
              Frequently Asked Questions
            </h2>
            
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginTop: '24px', marginBottom: '8px', color: '#000' }}>
              How does Pique work?
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Pique shows you other users who are within 100 feet of your current location. You can send messages, connect, and meet people who are actually nearby in real-time.
            </p>
            
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginTop: '24px', marginBottom: '8px', color: '#000' }}>
              What's the difference between Dating Mode and Networking Mode?
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Dating Mode is designed for meeting potential romantic partners, showing relationship status and personal interests. Networking Mode is for professional connections, displaying job titles, companies, and professional bios.
            </p>
            
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginTop: '24px', marginBottom: '8px', color: '#000' }}>
              How do I delete my account?
            </h3>
            <p style={{ marginBottom: '16px' }}>
              You can delete your account from the Settings tab within the app. This will permanently remove your profile and all associated data.
            </p>
            
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginTop: '24px', marginBottom: '8px', color: '#000' }}>
              How do I cancel my premium subscription?
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Subscriptions are managed through Apple. Go to Settings → Apple ID → Subscriptions on your iPhone to manage or cancel your Pique subscription.
            </p>
            
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginTop: '24px', marginBottom: '8px', color: '#000' }}>
              Why can't I see anyone nearby?
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Make sure location permissions are enabled for Pique. You'll only see users who are within 100 feet and using the same mode (Dating or Networking) as you.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Home page
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      padding: '20px',
    }}>
      <h1 style={{
        fontSize: 'clamp(80px, 20vw, 180px)',
        fontWeight: '700',
        color: '#000',
        marginBottom: '24px',
        letterSpacing: '-4px',
      }}>
        Pique
      </h1>
      
      <p style={{
        fontSize: '18px',
        color: '#666',
        textAlign: 'center',
        maxWidth: '500px',
        marginBottom: '48px',
        lineHeight: '1.6',
      }}>
        The location-based app that connects you with people within 100 feet. 
        Meet singles in Dating Mode or professionals in Networking Mode — 
        connect with people who are actually nearby, right now.
      </p>
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
        maxWidth: '300px',
      }}>
        <a
          href="#privacy-policy"
          onClick={(e) => { e.preventDefault(); navigateTo('privacy-policy'); }}
          style={{
            display: 'block',
            padding: '16px 32px',
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#000',
            color: '#fff',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            textDecoration: 'none',
            textAlign: 'center',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          Privacy Policy
        </a>
        
        <a
          href="#terms-and-conditions"
          onClick={(e) => { e.preventDefault(); navigateTo('terms'); }}
          style={{
            display: 'block',
            padding: '16px 32px',
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#fff',
            color: '#000',
            border: '2px solid #000',
            borderRadius: '12px',
            cursor: 'pointer',
            textDecoration: 'none',
            textAlign: 'center',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          Terms and Conditions
        </a>
        
        <a
          href="#support"
          onClick={(e) => { e.preventDefault(); navigateTo('support'); }}
          style={{
            display: 'block',
            padding: '16px 32px',
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#fff',
            color: '#000',
            border: '2px solid #000',
            borderRadius: '12px',
            cursor: 'pointer',
            textDecoration: 'none',
            textAlign: 'center',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          Support
        </a>
      </div>
      
      {/* Hidden links for Google crawler - these are actual anchor tags that Google can follow */}
      <nav style={{ marginTop: '60px', textAlign: 'center' }}>
        <p style={{ fontSize: '14px', color: '#999', marginBottom: '8px' }}>Quick Links</p>
        <a href="#privacy-policy" style={{ color: '#666', margin: '0 12px', fontSize: '14px' }}>Privacy Policy</a>
        <a href="#terms-and-conditions" style={{ color: '#666', margin: '0 12px', fontSize: '14px' }}>Terms and Conditions</a>
        <a href="#support" style={{ color: '#666', margin: '0 12px', fontSize: '14px' }}>Support</a>
      </nav>
    </div>
  );
}

export default App;